import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";
import InputComboDzien from "../../helpers/InputComboDzien";
import InputDate from "../../helpers/InputDate";
import InputTime from "../../helpers/InputTime";
import InputSearchEmp from "../../helpers/InputSearchEmp";
import InputCombo from "../../helpers/InputCombo";
import InputText from "../../helpers/InputText";
import InputTextArea from "../../helpers/InputTextArea";
import InputChecbox from "../../helpers/InputCheckbox";
import MenuTable from "../../helpers/MenuTable";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Xlsx from "../../exporter/Xlsx";
import Print from "../../exporter/Print";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import AppContext from "../../AppContext";
import FormatTime from "../../helpers/FormatTime";


export default function Lesson(props)
{

    const tabRef = useRef(0);
    const tab2Ref = useRef(0);

    const tabRefB = useRef(0);
    const tab2RefB = useRef(0);

    
 
    const [filterParam, setFilterParam] = useState({  

        men_dziennik_id: props.id,
        dzien_od: props.mainView.readFilter('dzien_od',''), 
        dzien_do: props.mainView.readFilter('dzien_do',''), 

        temat: props.mainView.readFilter('temat',''), 
        pracownik: props.mainView.readFilter('pracownik',''), 

        men_sl_podstawa_id: props.mainView.readFilter('men_sl_podstawa_id','_x_'), 

        rok: props.mainView.readFilter('rok',    (new Date()).getFullYear()  ), 
        miesiac: props.mainView.readFilter('miesiac',   (new Date()).getMonth()+1  ), 
       
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);
    const [tabM, setTabM] = useState(null);
 

    const [wyd, setWyd] = useState(null);


     const [itemSelected, setItemSelected] = useState(1);

 


    const [errTab, setErrTab] = useState([]);  //z info od serwera..

    const [punktyPodstawy, setPunktyPodstawy] = useState(null);

    //zaznaczone wg. wybranego tematu..
    const [podstawaSzczegoly, setPodstawaSzczegoly] = useState(null);

    const [copyPoint, setCopyPoint] = useState(false);


    const rowDef = {
        id: -1,
        men_dziennik_id: props.id,
        nauczyciel_px_group_id: -1,
        dzien:  new Date().toISOString().split`T`[0],    
        godzina_od: "08:00",    
        godzina_do: "16:00",    
        temat: "",    
        opis: "",    

        xv_wydawnictwa_id: -1,
        poziom_klasa: "",
        krag_tematyczny: "",

        punkty_podstawy: [],

    };
    const [row, setRow] = useState(rowDef);

    //dziennik specjalisty - bez podręcznika i podstawy programowej
    const isSpecjalisty = (props.typ == "specjalisty");

    const valChangeListenerRow = (filedName, val, correct, msg) => {

        console.log("valChangeListenerRow: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
 
        
        if(filedName == "men_dziennik_id")
        {
               setRow( {...row,  [filedName]:val,  [filedName+"_valid"]:correct ,["poziom_klasa"]:"",  ["poziom_klasa_valid"]:true,  ["krag_tematyczny"]:"",  ["krag_tematyczny_valid"]:true, ["opis"]:"",  ["opis_valid"]:false } );               
               setPodstawaSzczegoly(null);
        }else 
        if(filedName == "poziom_klasa")
        {
               setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct,  ["krag_tematyczny"]:"",  ["krag_tematyczny_valid"]:true, ["opis"]:"",  ["opis_valid"]:false } );               
               setPodstawaSzczegoly(null);
        }else 
        if(filedName == "krag_tematyczny")
        {
               setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct,  ["temat"]:"",  ["temat_valid"]:false , ["opis"]:"",  ["opis_valid"]:false } );               
               setPodstawaSzczegoly(null);
        }else 
        if(filedName == "temat" && !isSpecjalisty)
        {
               setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct,  ["opis"]:"",  ["opis_valid"]:false } );               
               setPodstawaSzczegoly(null);
        }else 
        {
                setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );   
        }
      
    }  

    const valChangeListenerPunkty = (filedName, val, correct, msg) => {

          console.log("valChangeListenerPunkty: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     

            if(correct == false) return;
        
          var tmpRow =  podstawaSzczegoly.lista;

          var index = val;
 

          if(tmpRow[index].selected  == 0)
          {
            tmpRow[index].selected = 1;
          }else  
            if(tmpRow[index].selected  == 1)  
            tmpRow[index].selected = 0;

          setPodstawaSzczegoly({...podstawaSzczegoly, ["lista"]: tmpRow  } );
    }




       const [view, setView] = useState ( {
            v:'list',
            id: -1
        } );
       
        const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
            setRow(rowDef);
            setPodstawaSzczegoly(null);
        }


   const clickTab = (e) => {

        var t = e.target.getAttribute("atr-tab");
        setItemSelected(t);
    }

        
 


    const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );

             if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
           

            props.mainView.writeFilter(filedName, val);
        }

    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }

            
      const filterClear = () => {
 
            props.mainView.writeFilter('dzien_od', '');
            props.mainView.writeFilter('dzien_do', '');
            props.mainView.writeFilter('temat', '');
            props.mainView.writeFilter('pracownik', '');
            props.mainView.writeFilter('men_sl_podstawa_id', '_x_');

            props.mainView.writeFilter('rok',   (new Date()).getFullYear()  );
            props.mainView.writeFilter('miesiac',    (new Date()).getMonth()+1  );
       
            setFilterParam({
 
                men_dziennik_id: props.id,
                dzien_od: '',                 
                dzien_do: '',                 
                temat: '',                 
                pracownik: '',                 
                men_sl_podstawa_id: '',                 

                rok:    (new Date()).getFullYear()  ,                 
                miesiac:    (new Date()).getMonth()+1  ,                 
                        

                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },


                limit: 50,
                page: 1,
                show: true, 
            });
            setTab(null);
        }


 const filterApprove = () => {   
     setTab(null)     
 }





const getTab = () => {
       
 
    props.mainView.setProgress(-2);
   

    fetch( Config.url + '/rest_v1_men,lessons', {
        method: 'POST', 
        body: JSON.stringify(filterParam), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setTab(res.result);             

                    if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}


const getTabM = () => {
       
 
    props.mainView.setProgress(-2);
   

    fetch( Config.url + '/rest_v1_men,lessons_m', {
        method: 'POST', 
        body: JSON.stringify(filterParam), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setTabM(res.result);             

                    if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}

 

const getWyd = () => {
       
 
    props.mainView.setProgress(-2);
   

    fetch( Config.url + '/rest_v1_men,wyd_poziomy', {
        method: 'POST', 
        body: JSON.stringify(filterParam), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setWyd(res.result);                         
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}



const getPunktyPodstawy= () => {
       
 
    props.mainView.setProgress(-2);
   

    fetch( Config.url + '/rest_v1_men,punkty_podstawy', {
        method: 'POST', 
        body: JSON.stringify(filterParam), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setPunktyPodstawy(res.result);                         
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}




const getPunktyPodstawyWgTematu = () => {
       
 
 


    var req = {
        xv_wydawnictwa_id: row.xv_wydawnictwa_id,
        poziom_klasa:      row.poziom_klasa,
        krag_tematyczny:   row.krag_tematyczny,
        temat:   row.temat,
    };



    props.mainView.setProgress(-2);
   

    fetch( Config.url + '/rest_v1_men,wyd_podstawa', {
        method: 'POST', 
        body: JSON.stringify(req), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {                                                       
                    setPodstawaSzczegoly(res.result);

                   if(view.v == "new")  setRow( {...row, ["opis"]:res.result.tresc_zajec,  ["opis_valid"]:true } );   

                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}


const getPunktyPodstawyWgTematuBefEdit = (xv_wydawnictwa_id, poziom_klasa, krag_tematyczny, temat) => {
       
 
 


    var req = {
        xv_wydawnictwa_id:  xv_wydawnictwa_id,
        poziom_klasa:      poziom_klasa,
        krag_tematyczny:   krag_tematyczny,
        temat:   temat,
    };



    props.mainView.setProgress(-2);
   

    fetch( Config.url + '/rest_v1_men,wyd_podstawa', {
        method: 'POST', 
        body: JSON.stringify(req), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {                                                
                    setPodstawaSzczegoly( res.result);
                    setCopyPoint(true);
                    //setRow( {...row, ["opis"]:res.result.tresc_zajec,  ["opis_valid"]:true } );   
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}


const goSelDes = (h) => {
    
    var selected = h.target.getAttribute('atr-selected');

    var tmp = JSON.parse(  JSON.stringify(podstawaSzczegoly)  );

 

    for(var k=0; k< tmp.lista.length; k++)
    {
        tmp.lista[k].selected = selected;
        console.log(tmp[k]);
    }


    setPodstawaSzczegoly(tmp);


}



const saveData = () => {


   

    if(podstawaSzczegoly == null && !isSpecjalisty) {

        props.mainView.showDialog( "Error", "Uzupełnij lub zweryfikuj punkty podstawy programowej." , "ok" ,  (param) => {
            getPunktyPodstawyWgTematu();
        } );
        return;
    }


    var req = row;
    req["punkty_podstawy"] = isSpecjalisty ? [] : podstawaSzczegoly.lista;

 
    if(req.nauczyciel_px_group_id.length < 4) {

        props.mainView.showDialog( "Error", "Wybierz nauczyciela prowadzącego" , "ok" , null);  
        return;
    }



    if(req.dzien.length < 3) {

        props.mainView.showDialog( "Error", "Wybierz dzień" , "ok" , null);  
        return;
    }

    if(req.godzina_od.length < 3) {

        props.mainView.showDialog( "Error", "Wybierz godzinę rozpoczęcia" , "ok" , null);  
        return;
    }

    if(req.godzina_do.length < 3) {

        props.mainView.showDialog( "Error", "Wybierz godzinę zakończenia" , "ok" , null);  
        return;
    }

     if(req.temat.length < 3) {

        props.mainView.showDialog( "Error", "Podaj temat zajęć" , "ok" , null);  
        return;
    }

     if(req.opis.length < 3) {

        props.mainView.showDialog( "Error", "Podaj opis zajęć" , "ok" , null);  
        return;
    }


  

    


    props.mainView.setProgress(-2);
   

    fetch( Config.url + '/rest_v1_men,lesson_set', {
        method: 'POST', 
        body: JSON.stringify(req), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {                                                       
                     props.mainView.showDialog( "Sukces", "Wpis w dzienniku zajęć został dodany" , "ok" , (param)=>{
                            getTab();
                            getTabM();
                            setView({v:'list',id: -1 })
                     } );  
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;

}



const deleteLesson = (e) => {

     var id = e.target.getAttribute("id");
    props.mainView.showDialog( "Pytanie", "Na pewno chcesz usunąć wpis w dzienniczku" , "yesno" ,  (param) => {
            
                if(param == "yes")
                {
                   deleteLessonYes(id)
                }
        } );
}

const deleteLessonYes = (id)  => {

    
    var req = {
        id: id
    };

    props.mainView.setProgress(-2);
   

    fetch( Config.url + '/rest_v1_men,lesson_remove', {
        method: 'POST', 
        body: JSON.stringify(req), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {                                                       
                     props.mainView.showDialog( "Sukces", "Wpis został usunięty" , "ok" , (param)=>{
                            getTab();
                            getTabM();
                            setView({v:'list',id: -1 })
                     } );  
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;

}





const prepereToEdit = (e) => {

     var id = e.target.getAttribute("id");

     var findInx = -1;
     
     for(var k=0; k < tab.length; k++)
     {
        if(tab[k].id == id ){
            findInx = k;
            break;
        }
     }

    

     setRow({
        id: id,
        men_dziennik_id: props.id,
        nauczyciel_px_group_id: tab[findInx].nauczyciel.id + " | " + tab[findInx].nauczyciel.imie + " " + tab[findInx].nauczyciel.nazwisko ,
        dzien:  tab[findInx].dzien,    
        godzina_od:  tab[findInx].godzina_od,    
        godzina_do:  tab[findInx].godzina_do,    
        temat:  tab[findInx].temat,    
        opis:  tab[findInx].opis,    

        xv_wydawnictwa_id:  tab[findInx].xv_wydawnictwa_id,
        poziom_klasa:  tab[findInx].poziom_klasa,
        krag_tematyczny:  tab[findInx].krag_tematyczny,

        punkty_podstawy:tab[findInx].punkty_podstawy, 

    });


    setView({
        v: 'edit', id: id
    });

    if(!isSpecjalisty) getPunktyPodstawyWgTematuBefEdit(tab[findInx].xv_wydawnictwa_id, tab[findInx].poziom_klasa, tab[findInx].krag_tematyczny , tab[findInx].temat);

}



   if(tab == null)
   {
      setTab([]);
      setTabM([]);

      getTab();      
      getTabM();
      getWyd();
      getPunktyPodstawy();
      return <div>...</div>
   }

   if(wyd == null || wyd.length < 1) {
    return <div>......</div>
   }

   var viewDialog = null;


   if(view.v == "new")
   {
        var poziomy = [];
        var kragi = [];
        var tematy = [];


        if(row.xv_wydawnictwa_id > 0)
        {

            for(var k=0; k < wyd.wydawnictwo.length; k++)
            {
                if( wyd.wydawnictwo[k].v == row.xv_wydawnictwa_id )
                {
                    poziomy = wyd.wydawnictwo[k].poziomy;
                

                    if(row.poziom_klasa.length > 2)
                    {
                        for(var w=0; w < poziomy.length; w++)
                        {
                            if(poziomy[w].v == row.poziom_klasa)
                            {
                                kragi = poziomy[w].kragi;
                                

                                if(row.krag_tematyczny.length > 2)
                                { 
                                    for(var s=0; s < kragi.length; s++)
                                    {
                                        if(kragi[s].v == row.krag_tematyczny)
                                        {
                                            tematy = kragi[s].tematy;
                                        }
                                    }
                                }


                            }
                        }
                    }

                }

            }

        }

 

        viewDialog =   <div className="dlg_window dlg_type_xx shadowx">
            
                    <div className="dlg_title">
                        Nowy temat zajęć
                    </div>

                    <div className="dlg_content_x scroll500">

                             <div className="form_tab">
                                
                                            <div className="form_control">
                                                <div className="fieldName">Dzień</div>
                                                <InputDate   userData={props.userData} value={row.dzien} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="dzien" placeholder={"Dzień: "} className=' w150 ' req='1' firstUp="1" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Rozpoczęcie</div>
                                                <InputTime   userData={props.userData} value={row.godzina_od} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="godzina_od" placeholder={"Godzina: "} className=' w150 ' req='1' firstUp="1" />
                                            </div>

                                             <div className="form_control">
                                                <div className="fieldName">Zakończenie</div>
                                                <InputTime   userData={props.userData} value={row.godzina_do} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="godzina_do" placeholder={"Godzina: "} className=' w150 ' req='1' firstUp="1" />
                                            </div>

                                            <div className="form_split"></div>   

                                             <div className="form_control">
                                                <div className="fieldName">Imię i nazwisko nauczyciela</div>
                                                <InputSearchEmp userData={props.userData} mainView={props.mainView}  value={row.nauczyciel_px_group_id} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="nauczyciel_px_group_id" placeholder={""} className=' w200 ' me="1" req='1' firstUp="1" />
                                            </div>

                                             <div className="form_split"></div>   


                                           



                                            {
                                                !isSpecjalisty &&
                                                <div className="form_control">
                                                    <div className="fieldName">Wyszukaj w podręczniku</div>
                                                    <InputCombo items={wyd.wydawnictwo} userData={props.userData} mainView={props.mainView}  value={row.xv_wydawnictwa_id} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="xv_wydawnictwa_id" placeholder={""} className=' w200 ' req='1' firstUp="1" />
                                                </div>
                                            }



                                              {
                                                row.xv_wydawnictwa_id < 1 &&
                                                <Fragment>
                                                    {
                                                        !isSpecjalisty &&
                                                        <b>LUB</b>
                                                    }
                                                    <div className="form_control">
                                                        <div className="fieldName">{isSpecjalisty ? "Temat zajęć" : "Temat własny"}</div>
                                                        <InputText   userData={props.userData} value={row.temat} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="temat" placeholder={"Temat: "} className=' w300 ' req={isSpecjalisty ? '1' : '0'} firstUp="1" />
                                                    </div>
                                                </Fragment>
                                              }
                                             

                                            {
                                                row.xv_wydawnictwa_id > 0 &&
                                                <Fragment>

                                                        <div className="form_control">
                                                            <div className="fieldName">Poziom</div>
                                                            <InputCombo items={poziomy} userData={props.userData} mainView={props.mainView}  value={row.poziom_klasa} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="poziom_klasa" placeholder={""} className=' w200 ' req='1' firstUp="1" />
                                                        </div>

                                                        <div className="form_control">
                                                            <div className="fieldName">Krąg tematyczny</div>
                                                            <InputCombo items={kragi} userData={props.userData} mainView={props.mainView}  value={row.krag_tematyczny} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="krag_tematyczny" placeholder={""} className=' w200 ' req='1' firstUp="1" />
                                                        </div>

                                                        <div className="form_control">
                                                            <div className="fieldName">Temat z podręcznika</div>
                                                            <InputCombo items={tematy} userData={props.userData} mainView={props.mainView}  value={row.temat} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="temat" placeholder={""} className=' w300 ' req='1' firstUp="1" />
                                                        </div>

                                                </Fragment>
                                            }

                                            {
                                                !isSpecjalisty &&
                                                <Fragment>
                                                    <div className="form_split"></div>
                                                        <span className="link_color gobold" onClick={getPunktyPodstawyWgTematu} >Kliknij tutaj - pobierz opis zajęć i podstawę programową wg. tematu</span>
                                                        <br/>&nbsp;
                                                    <div className="form_split"></div>
                                                </Fragment>
                                            }

                                            {
                                                    podstawaSzczegoly != null && !isSpecjalisty &&
                                                    <Fragment>

                                                            <div>
                                                                    <span className="link_color" atr-selected="1" onClick={goSelDes} >Zaznacz wszystkie</span>  
                                                                    &nbsp; &nbsp; &nbsp; &nbsp; 
                                                                    <span className="link_color" atr-selected="0" onClick={goSelDes} >Odznacz wszystkie</span>  
                                                            </div>                                                          

                                                            <div className="form_control p100">
                                                                <ul className="men_podstawa_punkty">
                                                                 {
                                                                    podstawaSzczegoly.lista.map( (item, ixRow) => {

                                                                        var isChecked = false;
                                                                        if(item.selected == '1') isChecked = true;

                                                                        return <li>
                                                                                   <InputChecbox  title={ " " +  item.uq + " " +  item.opis} checked={isChecked} value={ixRow} err={errTab}  valChange={valChangeListenerPunkty} goNext={goNextNew} name={item.uq} placeholder={": "} className='   ' req='0' firstUp="0" />
                                                                                  
                                                                            </li>
                                                                    } )
                                                                 }
                                                                 </ul>
                                                            </div>
                                                       
                                                    </Fragment>

                                            }

                                            <div className="form_control p100">
                                                            <div className="fieldName">Opis zajęć / notatka</div>
                                                            <InputTextArea   value={row.opis} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="opis" placeholder={""} className=' p100 h100 ' req='1' firstUp="1" />
                                            </div>


                                            
                                            <div className="form_split"></div>

                                            <div className="form_control">                                            
                                                <div className="btn" onClick={saveData}>dodaj</div>
                                                &nbsp; &nbsp;
                                                <div className="btn" onClick={changeView}>anuluj</div>
                                            </div>

                                           

                             </div>

                    </div>
        </div>

   }


    if(view.v == "edit")
   {
        var poziomy = [];
        var kragi = [];
        var tematy = [];


        if(row.xv_wydawnictwa_id > 0)
        {

            for(var k=0; k < wyd.wydawnictwo.length; k++)
            {
                if( wyd.wydawnictwo[k].v == row.xv_wydawnictwa_id )
                {
                    poziomy = wyd.wydawnictwo[k].poziomy;
                

                    if(row.poziom_klasa.length > 2)
                    {
                        for(var w=0; w < poziomy.length; w++)
                        {
                            if(poziomy[w].v == row.poziom_klasa)
                            {
                                kragi = poziomy[w].kragi;
                                

                                if(row.krag_tematyczny.length > 2)
                                { 
                                    for(var s=0; s < kragi.length; s++)
                                    {
                                        if(kragi[s].v == row.krag_tematyczny)
                                        {
                                            tematy = kragi[s].tematy;
                                        }
                                    }
                                }


                            }
                        }
                    }

                }

            }

        }


        if(copyPoint)
        {
            setCopyPoint(false);

            console.log("Z1",row.punkty_podstawy);
            console.log("Z2",podstawaSzczegoly);

            var tmpTab = JSON.parse( JSON.stringify(podstawaSzczegoly) );


           
            for(var k = 0; k < tmpTab.lista.length; k++)
            {
                var isSelected = "0"; 

                for(var w=0; w < row.punkty_podstawy.length; w++)
                {
                    if(row.punkty_podstawy[w].uq == tmpTab.lista[k].uq )
                    {                        
                        isSelected = "1";
                        break;
                    }
                }

                tmpTab.lista[k].selected = isSelected; 
            }

            setPodstawaSzczegoly(tmpTab);

        }
 

        viewDialog =   <div className="dlg_window dlg_type_xx shadowx">
            
                    <div className="dlg_title">
                        Nowy temat zajęć
                    </div>

                    <div className="dlg_content_x scroll500">

                             <div className="form_tab">
                                
                                            <div className="form_control">
                                                <div className="fieldName">Dzień</div>
                                                <InputDate   userData={props.userData} value={row.dzien} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="dzien" placeholder={"Dzień: "} className=' w150 ' req='1' firstUp="1" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Rozpoczęcie</div>
                                                <InputTime   userData={props.userData} value={row.godzina_od} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="godzina_od" placeholder={"Godzina: "} className=' w150 ' req='1' firstUp="1" />
                                            </div>

                                             <div className="form_control">
                                                <div className="fieldName">Zakończenie</div>
                                                <InputTime   userData={props.userData} value={row.godzina_do} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="godzina_do" placeholder={"Godzina: "} className=' w150 ' req='1' firstUp="1" />
                                            </div>

                                            <div className="form_split"></div>   

                                             <div className="form_control">
                                                <div className="fieldName">Imię i nazwisko nauczyciela</div>
                                                <InputSearchEmp userData={props.userData} mainView={props.mainView}  value={row.nauczyciel_px_group_id} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="nauczyciel_px_group_id" placeholder={""} className=' w200 ' req='1' firstUp="1" />
                                            </div>

                                             <div className="form_split"></div>   


                                            <div className="form_control">
                                                <div className="fieldName">Temat własny</div>
                                                <InputText   userData={props.userData} value={row.temat} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="temat" placeholder={"Temat: "} className=' w300 ' req='1' firstUp="1" />
                                            </div>

                                            {
                                                !isSpecjalisty &&
                                                <Fragment>
                                                    LUB


                                                     <div className="form_control">
                                                        <div className="fieldName">Wyszukaj w podręczniku</div>
                                                        <InputCombo items={wyd.wydawnictwo} userData={props.userData} mainView={props.mainView}  value={row.xv_wydawnictwa_id} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="xv_wydawnictwa_id" placeholder={""} className=' w200 ' req='1' firstUp="1" />
                                                    </div>
                                                </Fragment>
                                            }

                                            {
                                                row.xv_wydawnictwa_id > 0 && !isSpecjalisty &&
                                                <Fragment>

                                                        <div className="form_control">
                                                            <div className="fieldName">Poziom</div>
                                                            <InputCombo items={poziomy} userData={props.userData} mainView={props.mainView}  value={row.poziom_klasa} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="poziom_klasa" placeholder={""} className=' w200 ' req='1' firstUp="1" />
                                                        </div>

                                                        <div className="form_control">
                                                            <div className="fieldName">Krąg tematyczny</div>
                                                            <InputCombo items={kragi} userData={props.userData} mainView={props.mainView}  value={row.krag_tematyczny} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="krag_tematyczny" placeholder={""} className=' w200 ' req='1' firstUp="1" />
                                                        </div>

                                                        <div className="form_control">
                                                            <div className="fieldName">Temat z podręcznika</div>
                                                            <InputCombo items={tematy} userData={props.userData} mainView={props.mainView}  value={row.temat} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="temat" placeholder={""} className=' w300 ' req='1' firstUp="1" />
                                                        </div>

                                                </Fragment>
                                            }


                                            <div className="form_split"></div>

                                            <div className="form_control">                                            
                                                <div className="btn" onClick={saveData}>zapisz</div>
                                                &nbsp; &nbsp;
                                                <div className="btn" onClick={changeView}>anuluj</div>
                                            </div>

                                            <div className="form_split"></div>
                                            <br/>
                                            <div className="form_split"></div>


                                            {
                                                !isSpecjalisty &&
                                                <Fragment>
                                                    <div className="form_split"></div>
                                                        <span className="link_color" onClick={getPunktyPodstawyWgTematu} >Kliknij tutaj - pobierz opis zajęć i podstawę programową wg. tematu</span>
                                                        <br/>&nbsp;
                                                    <div className="form_split"></div>
                                                </Fragment>
                                            }

                                            {
                                                    podstawaSzczegoly != null && !isSpecjalisty &&
                                                    <Fragment>

                                                          <div>
                                                                    <span className="link_color" atr-selected="1" onClick={goSelDes} >Zaznacz wszystkie</span>  
                                                                    &nbsp; &nbsp; &nbsp; &nbsp; 
                                                                    <span className="link_color" atr-selected="0" onClick={goSelDes} >Odznacz wszystkie</span>  
                                                            </div>   

                                                            <div className="form_control p100">
                                                                <ul className="men_podstawa_punkty">
                                                                 {
                                                                    podstawaSzczegoly.lista.map( (item, ixRow) => {

                                                                        var isChecked = false;
                                                                        if(item.selected == '1') isChecked = true;

                                                                        return <li>
                                                                                   <InputChecbox  title={ "  " +  item.uq + " " +  item.opis} checked={isChecked} value={ixRow} err={errTab}  valChange={valChangeListenerPunkty} goNext={goNextNew} name={item.uq} placeholder={": "} className='   ' req='0' firstUp="0" />
                                                                                  
                                                                            </li>
                                                                    } )
                                                                 }
                                                                 </ul>
                                                            </div>
                                                       
                                                    </Fragment>

                                            }

                                            <div className="form_control p100">
                                                            <div className="fieldName">Opis zajęć / notatka</div>
                                                            <InputTextArea   value={row.opis} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="opis" placeholder={""} className=' p100 h100 ' req='1' firstUp="1" />
                                            </div>


                                            
                                            <div className="form_split"></div>

                                            <div className="form_control">                                            
                                                <div className="btn" onClick={saveData}>zapisz</div>
                                                &nbsp; &nbsp;
                                                <div className="btn" onClick={changeView}>anuluj</div>
                                            </div>

                                           

                             </div>

                    </div>
        </div>

   }



   var itemsPunkty = new Array();
   itemsPunkty.push({
    v: "_x_", title: " --- ",
   });

   for(var k=0; k < punktyPodstawy.length; k++)
   {
        var ttt = punktyPodstawy[k].opis.substring(0,30) + " ... ";

        itemsPunkty.push({
            v: punktyPodstawy[k].id,
            title: punktyPodstawy[k].uq + " " + ttt,
        });
   }


    var cssTab1 = "";
    var cssTab2 = "";
    var cssTab3 = "";
    var cssTab4 = "";
    var cssTab5 = "";
    var cssTab6 = "";
    var cssTab7 = "";

    if(itemSelected == 1) cssTab1 = " xActive ";
    if(itemSelected == 2) cssTab2 = " xActive ";
    if(itemSelected == 3) cssTab3 = " xActive ";
    if(itemSelected == 4) cssTab4 = " xActive ";
    if(itemSelected == 5) cssTab5 = " xActive ";
    if(itemSelected == 6) cssTab6 = " xActive ";
    if(itemSelected == 7) cssTab7 = " xActive ";


   var sumMinute = 0;


    return <div>
          

                   <div className="xTabs">
                        <div className={"xItem " + cssTab1  } atr-tab="1" onClick={clickTab}  >Pełna lista zajęć</div>
                        <div className={"xItem " + cssTab2 } atr-tab="2" onClick={clickTab}  >Raport miesięczny</div>
                   </div>



                    <div className="xtabs_content">


                            {
                                itemSelected == 1 &&
                                <Fragment>


                                                    <div className="table_filter">
                                                    
                                                        
                                                                        <div className="filter_controll">   
                                                                                <label>Od dnia: </label>                             
                                                                                <InputDate   userData={props.userData}  mainView={props.mainView}   value={filterParam.dzien_od}   valChange={valChangeListener} goNext={goNextNew} name="dzien_od" placeholder={": "}  noempty="0"   />
                                                                        </div>

                                                                        <div className="filter_controll">   
                                                                                <label>Do dnia: </label>                             
                                                                                <InputDate   userData={props.userData}  mainView={props.mainView}   value={filterParam.dzien_do}   valChange={valChangeListener} goNext={goNextNew} name="dzien_do" placeholder={": "}  noempty="0"   />
                                                                        </div>

                                                                        <div className="filter_controll">   
                                                                                <label>Temat: </label>                             
                                                                                <InputText   userData={props.userData}  mainView={props.mainView}   value={filterParam.temat}   valChange={valChangeListener} goNext={goNextNew} name="temat" placeholder={"Temat: "}     />
                                                                        </div>

                                                                        <div className="filter_controll">   
                                                                                <label>Nauczyciel: </label>                             
                                                                                <InputTextAlpha   userData={props.userData}  mainView={props.mainView}   value={filterParam.pracownik}   valChange={valChangeListener} goNext={goNextNew} name="pracownik" placeholder={"Pracownik: "}     />
                                                                        </div>

                                                                        <div className="filter_controll">   
                                                                                <label>Punkt podstawy: </label>                             
                                                                                <InputCombo items={itemsPunkty} value={filterParam.men_sl_podstawa_id}   valChange={valChangeListener} goNext={goNextNew} name="men_sl_podstawa_id" placeholder={"Podstawa: "}     />
                                                                        </div>
                                                                        

                                                                        <div className="filter_btn">                           
                                                                                    <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                                                                        </div>

                                                                </div>

                                                                <div className="table_widget">    
                                                                    
                                                                    {
                                                                        props.status == "aktywny" &&
                                                                        <div className="btn"  onClick={changeView} v="new" id="-1"  > dodaj temat zajęć</div>
                                                                    }
                                                                    

                                                                                &nbsp;&nbsp;                              

                                                                                <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={props.title  } />   

                                                                                <Csv tabRef={tab2Ref} title={ props.title + ".csv" } />
                                                                                <Xlsx tabRef={tab2Ref} title={ props.title  + ".xlsx" } />
                                                                    
                                                                                <Print tabRef={tab2Ref}  title={props.title} />

                                                                </div>


                                                                <div ref={tabRef} className="gohide">
                                                                    <h3>{props.title}</h3>   

                                                                                <table className="table" ref={tab2Ref}>

                                                                                            <thead>
                                                                                                    <tr className="header">                                                    
                                                                                                        <td className="td_left">LP</td>                                                                                                                                           
                                                                                                        <td className="">Dzień</td>                                                                                                                                           
                                                                                                        <td>Godzina</td>                                              
                                                                                                        <td>Czas</td>                                              
                                                                                                        <td>Nauczyciel</td>                                              
                                                                                                        <td >Temat</td>    
                                                                                                        <td >Opis</td>    
                                                                                                        <td className="td_right">Punkty podstawy prog.</td>                                                                                                                                                                                                                                     
                                                                                                                                                
                                                                                                    </tr>
                                                                                            </thead>

                                                                                            <tbody>

                                                                                                {
                                                                                                    tab.map( (item, ixKey) => {

                                                                                                        var rowStyle = " row ";
                                                                                                        if(ixKey % 2 == 0 )rowStyle = " row2 ";


                                                                                                        return <tr className={rowStyle} key={ixKey}>
                                                                                                                <td className="gocenter">{ixKey+1}</td>                                                                                                                                           
                                                                                                                <td className="gocenter">{item.dzien}</td>                                                                                                                                           
                                                                                                                <td className="gocenter">{item.godzina_od.substring(0,5)} / {item.godzina_do.substring(0,5)}</td>                                              
                                                                                                                <td className="gocenter"><FormatTime minute={item.ilosc_minut} /></td>                                              
                                                                                                                <td >{item.nauczyciel.nazwisko + " " + item.nauczyciel.imie}</td>    
                                                                                                                <td >{item.temat}</td>    
                                                                                                                <td >{item.opis}</td>    
                                                                                                                <td className="td_right">
                                                                                                                    {
                                                                                                                        item.punkty_podstawy.map( (pp, ixPP) => {
                                                                                                                            return <Fragment>
                                                                                                                                {pp.uq} , 
                                                                                                                            </Fragment>
                                                                                                                        } )
                                                                                                                    }
                                                                                                                </td>                                                                                                                                                                                                                                                                                                
                                                                                                        </tr>

                                                                                                    } )
                                                                                                }

                                                                                            </tbody>

                                                                                </table>

                                                                </div>

                                                                <div className="scorll_x">
                                                            

                                                                                <table className="table" >

                                                                                            <thead>
                                                                                                    <tr className="header">                                                    
                                                                                                        <td className="td_left">LP</td>                                                                                                                                           
                                                                                                        <td className="">Dzień</td>                                                                                                                                           
                                                                                                        <td>Godzina</td>                                              
                                                                                                        <td>Czas</td>                                              
                                                                                                        <td>Nauczyciel</td>                                              
                                                                                                        <td >Temat</td>    
                                                                                                        <td >Opis</td>    
                                                                                                        <td className="td_right">Punkty podstawy prog.</td>                                                                                                                                                                                                                                     
                                                                                                        <td className="td_option"> </td>                                              
                                                                                                    </tr>
                                                                                            </thead>

                                                                                            <tbody>

                                                                                                {
                                                                                                    tab.map( (item, ixKey) => {

                                                                                                        var rowStyle = " row ";
                                                                                                        if(ixKey % 2 == 0 )rowStyle = " row2 ";


                                                                                                        return <tr className={rowStyle} key={ixKey}>
                                                                                                                <td className="gocenter">{ixKey+1}</td>                                                                                                                                           
                                                                                                                <td className="gocenter">{item.dzien}</td>                                                                                                                                           
                                                                                                                <td className="gocenter">{item.godzina_od.substring(0,5)} / {item.godzina_do.substring(0,5)}</td>                                              
                                                                                                                <td className="gocenter"><FormatTime minute={item.ilosc_minut} /></td>                                              
                                                                                                                <td >{item.nauczyciel.nazwisko + " " + item.nauczyciel.imie}</td>    
                                                                                                                <td >{item.temat}</td>    
                                                                                                                <td >{item.opis}</td>    
                                                                                                                <td className="td_right">
                                                                                                                    {
                                                                                                                        item.punkty_podstawy.map( (pp, ixPP) => {
                                                                                                                            return <span>
                                                                                                                                {pp.uq}, &nbsp;
                                                                                                                            </span>
                                                                                                                        } )
                                                                                                                    }
                                                                                                                </td>                                                                                                                                                                                                                                     
                                                                                                                <MenuTable>
                                                                                                                            <ul> 
                                                                                                                                {
                                                                                                                                    props.status == "aktywny" &&
                                                                                                                                    <Fragment>
                                                                                                                                        <li  onClick={prepereToEdit}  id={item.id}  >edytuj</li>
                                                                                                                                        <li onClick={deleteLesson}  id={item.id}  >usuń</li>  
                                                                                                                                    </Fragment>
                                                                                                                                }                                                                      
                                                                                                                                                                                                    
                                                                                                                            </ul>                                                               
                                                                                                                </MenuTable>  
                                                                                                        </tr>

                                                                                                    } )
                                                                                                }

                                                                                            </tbody>

                                                                                </table>
                                                                </div>

                                </Fragment>
                            }




                            {
                                itemSelected == 2 &&
                                <Fragment>


                                                <div className="table_filter">
                                                    
                                                        
                                                                        <div className="filter_controll">   
                                                                                <label>Rok: </label>                             
                                                                                <InputComboRok  userData={props.userData}  mainView={props.mainView}   value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                                                                        </div>

                                                                        <div className="filter_controll">   
                                                                                <label>Miesiąc: </label>                             
                                                                                <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}   value={filterParam.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}    />
                                                                        </div>
                                                                       
                                                                        <div className="filter_controll">   
                                                                                <label>Nauczyciel: </label>                             
                                                                                <InputTextAlpha   userData={props.userData}  mainView={props.mainView}   value={filterParam.pracownik}   valChange={valChangeListener} goNext={goNextNew} name="pracownik" placeholder={"Pracownik: "}     />
                                                                        </div>
                                                                      
                                                                        

                                                                        <div className="filter_btn">                           
                                                                                    <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                                                                        </div>

                                                </div>



                                                 <div className="table_widget">    
                                                                                                                                                                                                          
                                                                                &nbsp;&nbsp;                              

                                                                                <HtmlToPDF tabRef={tabRefB} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={props.title  } />   

                                                                                <Csv tabRef={tab2RefB} title={ props.title + ".csv" } />
                                                                                <Xlsx tabRef={tab2RefB} title={ props.title  + ".xlsx" } />
                                                                    
                                                                                <Print tabRef={tab2RefB}  title={props.title} />

                                                                </div>


                                                                <div ref={tabRefB} className="gohide">
                                                                       <h3>{props.title}</h3>   
                                                                         <table className="table" ref={tab2RefB}>

                                                                                            <thead>
                                                                                                    <tr className="header">                                                    
                                                                                                        <td className="td_left">LP</td>                                                                                                                                           
                                                                                                        <td className="">Osoba</td>                                                                                                                                           
                                                                                                        <td className="">Rok</td>                                                                                                                                           
                                                                                                        <td className="">Miesiąc</td>                                                                                                                                           
                                                                                                        <td className="">Ilość minut</td>                                                                                                                                           
                                                                                                        <td className="">Czas (godz:min)</td>                                                                                                                                           
                                                                                                                                                   
                                                                                                    </tr>
                                                                                            </thead>

                                                                                            <tbody>

                                                                                                {
                                                                                                    tabM.map( (item, ixKey) => {

                                                                                                        var rowStyle = " row ";
                                                                                                        if(ixKey % 2 == 0 )rowStyle = " row2 ";

                                                                                                        sumMinute = parseInt(sumMinute ) + parseInt(item.ilosc_minut);


                                                                                                        return <tr className={rowStyle} key={ixKey}>
                                                                                                                <td className="gocenter">{ixKey+1}</td>                                                                                                                                           
                                                                                                                <td className="gocenter">{item.nazwisko} {item.imie}</td>                                                                                                                    
                                                                                                                <td className="gocenter">{item.rok}</td>                                                                                                                    
                                                                                                                <td className="gocenter">{item.miesiac}</td>                                                                                                                    
                                                                                                                <td className="gocenter">{item.ilosc_minut}</td>                                                                                                                    
                                                                                                                <td className="gocenter"><FormatTime minute={item.ilosc_minut} /></td>                                                                                                                    
                                                                                                        </tr>

                                                                                                    } )
                                                                                                }

                                                                                                       <tr>
                                                                                                                <td className="gocenter"> </td>                                                                                                                                           
                                                                                                                <td className="gocenter"> </td>                                                                                                                    
                                                                                                                <td className="gocenter"> </td>                                                                                                                    
                                                                                                                <td className="gocenter"> </td>                                                                                                                    
                                                                                                                <td className="gocenter gobold">{sumMinute}</td>                                                                                                                    
                                                                                                                <td className="gocenter gobold"><FormatTime minute={sumMinute} /></td>                                                                                                                    
                                                                                                        </tr>

                                                                                            </tbody>

                                                                                </table>
                                                                </div>

                                                
                                                                <div className="scorll_x">
                                                            

                                                                                <table className="table" >

                                                                                            <thead>
                                                                                                    <tr className="header">                                                    
                                                                                                        <td className="td_left">LP</td>                                                                                                                                           
                                                                                                        <td className="">Osoba</td>                                                                                                                                           
                                                                                                        <td className="">Rok</td>                                                                                                                                           
                                                                                                        <td className="">Miesiąc</td>                                                                                                                                           
                                                                                                        <td className="">Ilość minut</td>                                                                                                                                           
                                                                                                        <td className="">Czas (godz:min)</td>                                                                                                                                           
                                                                                                                                                   
                                                                                                    </tr>
                                                                                            </thead>

                                                                                            <tbody>

                                                                                                {
                                                                                                    tabM.map( (item, ixKey) => {

                                                                                                        var rowStyle = " row ";
                                                                                                        if(ixKey % 2 == 0 )rowStyle = " row2 ";


                                                                                                        return <tr className={rowStyle} key={ixKey}>
                                                                                                                <td className="gocenter">{ixKey+1}</td>                                                                                                                                           
                                                                                                                <td className="gocenter">{item.nazwisko} {item.imie}</td>                                                                                                                    
                                                                                                                <td className="gocenter">{item.rok}</td>                                                                                                                    
                                                                                                                <td className="gocenter">{item.miesiac}</td>                                                                                                                    
                                                                                                                <td className="gocenter">{item.ilosc_minut}</td>                                                                                                                    
                                                                                                                <td className="gocenter"><FormatTime minute={item.ilosc_minut} /></td>                                                                                                                    
                                                                                                        </tr>

                                                                                                    } )
                                                                                                }


                                                                                                        <tr>
                                                                                                                <td className="gocenter"> </td>                                                                                                                                           
                                                                                                                <td className="gocenter"> </td>                                                                                                                    
                                                                                                                <td className="gocenter"> </td>                                                                                                                    
                                                                                                                <td className="gocenter"> </td>                                                                                                                    
                                                                                                                <td className="gocenter gobold">{sumMinute}</td>                                                                                                                    
                                                                                                                <td className="gocenter gobold"><FormatTime minute={sumMinute} /></td>                                                                                                                    
                                                                                                        </tr>

                                                                                            </tbody>

                                                                                </table>
                                                                </div>


                                </Fragment>
                            }



                    </div>



          
             

             {viewDialog}

    </div>
}

